import { withInstall } from '../../../../utils/with-install'
import Labels from './Labels.vue'

export const ElAmapLayerLabels = withInstall(Labels)
export default ElAmapLayerLabels
